import { render, staticRenderFns } from "./NativeVideoPlayer.vue?vue&type=template&id=66357532&scoped=true"
import script from "./NativeVideoPlayer.vue?vue&type=script&lang=ts"
export * from "./NativeVideoPlayer.vue?vue&type=script&lang=ts"
import style0 from "./NativeVideoPlayer.vue?vue&type=style&index=0&id=66357532&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66357532",
  null
  
)

export default component.exports